// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".popup-layer[data-v-7767e060]{position:fixed;top:0;left:0;right:0;bottom:auto;height:100%;overflow:hidden;pointer-events:none;display:grid;z-index:100}", ""]);
// Exports
module.exports = exports;
